export default __webpack_public_path__ + "static/media/Curso-Excel-Avanzado.484d20b4.png";